export default __webpack_public_path__ + "static/devices-mobile-22d7ddae64846a77b859fd1ebdcbf51e.png";